var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.60608V10.7727M2.5 6.60608C2.5 9.15983 2.5 14.7512 2.5 15.0738C2.5 16.2259 4.12137 16.9108 7.36411 18.2807C8.66683 18.8309 9.31817 19.1061 10 19.1061V10.2351",
    stroke: "#757575",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.606C12.5 16.606 13.2292 16.606 13.9583 18.2727C13.9583 18.2727 16.2745 14.106 18.3333 13.2727",
    stroke: "#757575",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93827 8.84881L4.50393 7.67087C3.16797 7.02441 2.5 6.70119 2.5 6.18933C2.5 5.67747 3.16797 5.35425 4.50393 4.70779L6.93827 3.52985C8.44067 2.80284 9.19192 2.43933 10 2.43933C10.8081 2.43933 11.5593 2.80283 13.0617 3.52985L15.4961 4.70779C16.832 5.35425 17.5 5.67747 17.5 6.18933C17.5 6.70119 16.832 7.02441 15.4961 7.67087L13.0617 8.84881C11.5593 9.57583 10.8081 9.93933 10 9.93933C9.19192 9.93933 8.44067 9.57583 6.93827 8.84881Z",
    stroke: "#757575",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.7727L6.66667 11.606",
    stroke: "#757575",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 4.10608L5.8335 8.27275",
    stroke: "#757575",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/order-icon.75901d0c59d57198ff6f4cdd5743232e.svg";
export { ForwardRef as ReactComponent };